"use client";

import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Clarityauditcta() {
  const reduce = useReducedMotion();
  const headline = "Start your growth.";
  const words = headline.split(" ");
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: reduce ? 0 : 0.055,
        delayChildren: reduce ? 0 : 0.1
      }
    }
  };
  const wordVariants = {
    hidden: {
      opacity: 0,
      y: reduce ? 0 : 38
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: reduce ? 0 : 0.72,
        ease: [0.2, 0.7, 0.2, 1] as [number, number, number, number]
      }
    }
  };
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: reduce ? 0 : 8
    },
    visible: (i: number) => ({
      opacity: 1,
      y: 0,
      transition: {
        duration: reduce ? 0 : 0.5,
        delay: reduce ? 0 : 0.9 + i * 0.12,
        ease: [0.2, 0.7, 0.2, 1] as [number, number, number, number]
      }
    })
  };
  const kickerVariant = {
    hidden: {
      opacity: 0,
      y: reduce ? 0 : 8
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: reduce ? 0 : 0.4,
        delay: reduce ? 0 : 0.1,
        ease: [0.2, 0.7, 0.2, 1] as [number, number, number, number]
      }
    }
  };
  return <section data-section-id="30574" id="clarityauditcta" data-nav="light" className="w-full py-28 md:py-40 lg:py-52 bg-background text-foreground">
      <div className="mx-auto max-w-[1200px] px-6 md:px-12">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.3
      }} className="flex flex-col items-center text-center">
          {/* Eyebrow / Kicker */}
          <motion.p variants={kickerVariant} className="font-sans text-xs md:text-[15px] font-medium uppercase text-muted-foreground" style={{
          letterSpacing: "0.18em"
        }}>
            {"— Book your free consultation"}
          </motion.p>

          {/* Display Heading */}
          <motion.h2 variants={containerVariants} className="mt-12 font-serif font-normal text-foreground" style={{
          fontSize: "clamp(36px, 4.5vw, 58px)",
          letterSpacing: "-0.035em",
          lineHeight: "0.92"
        }}>
            {words.map((word, i) => {
            const isItalic = word.toLowerCase().startsWith("growth");
            return <span key={i} data-index={i} className="inline-block overflow-hidden align-baseline" style={{
              marginRight: i < words.length - 1 ? "0.25em" : 0
            }}>
                  <motion.span variants={wordVariants} className={`inline-block ${isItalic ? "italic" : ""}`} style={{
                willChange: "transform, opacity"
              }}>
                    {word}
                  </motion.span>
                </span>;
          })}
          </motion.h2>

          {/* Action CTAs */}
          <div className="mt-12 flex flex-wrap items-center justify-center gap-6">
            <motion.div custom={0} variants={fadeUp} className="w-full sm:w-auto max-w-[320px]">
              <Button asChild className="group h-auto w-full rounded-lg px-8 py-[18px] text-sm font-medium transition-colors duration-300 bg-primary text-primary-foreground" style={{
              letterSpacing: "0.02em"
            }}>
                <Link to="/ContactPage">
                  <span>Book a free consultation</span>
                  <ArrowRight className="ml-1 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={1.5} />
                </Link>
              </Button>
            </motion.div>

            <motion.div custom={1} variants={fadeUp} className="w-full sm:w-auto max-w-[320px]">
              <Button asChild variant="outline" className="h-auto w-full rounded-lg border-[1.5px] bg-transparent px-8 py-[18px] text-sm font-medium transition-colors duration-300 hover:bg-primary hover:text-primary-foreground border-primary text-primary" style={{
              letterSpacing: "0.02em"
            }}>
                <Link to="/CaseStudiesPage">
                  <span>Explore my case studies</span>
                </Link>
              </Button>
            </motion.div>
          </div>

          {/* Reassurance text */}
          <motion.p custom={2} variants={fadeUp} className="mt-8 font-sans text-[15px] text-muted-foreground">
            Speak directly with me to review your site and start improving your search performance.
          </motion.p>
        </motion.div>
      </div>
    </section>;
}